import React, { useState, useEffect } from 'react';
import { getInstructors,updateApprovalStatusInstructor } from '../services/api';
import { FaEye } from 'react-icons/fa';
import ReactPaginate from 'react-paginate';
import { useLocation } from 'react-router-dom';

const InstructorsDocuments = () => {
  const [instructors, setInstructors] = useState([]);
  const [allInstructors, setAllInstructors] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [filters, setFilters] = useState({
    approvalStatus: '',
    isDualRole: '',
    isOnboardingComplete: '',
  });
  const [sort, setSort] = useState('createdAt');
  const [order, setOrder] = useState('desc');
  const [expandedRows, setExpandedRows] = useState({});
  const [search, setSearch] = useState('');
  const [editModeUid, setEditModeUid] = useState(null);
  const [editedStatus, setEditedStatus] = useState('');
  const [selectedUids, setSelectedUids] = useState([]);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [bulkAction, setBulkAction] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [profileModalOpen, setProfileModalOpen] = useState(false);
  const [selectedInstructor, setSelectedInstructor] = useState(null);
  const location = useLocation();

  useEffect(() => {
    const fetchInstructors = async () => {
      try {
        const data = await getInstructors();
        setAllInstructors(Array.isArray(data) ? data : data.documents || []);
      } catch (error) {
        console.error('Failed to fetch instructors:', error);
      }
    };

    fetchInstructors();
  }, []);

  useEffect(() => {
    const applyFilters = () => {
      let filtered = [...allInstructors];

      // Filter by approval status, dual role, onboarding
      if (filters.approvalStatus)
        filtered = filtered.filter((o) => o.approvalStatus === filters.approvalStatus);

      if (filters.isDualRole)
        filtered = filtered.filter((o) => String(o.isDualRole) === filters.isDualRole);

      if (filters.isOnboardingComplete)
        filtered = filtered.filter((o) => String(o.isOnboardingComplete) === filters.isOnboardingComplete);

      // Search by phone, name, or  name
      if (search.trim()) {
        const lowerSearch = search.toLowerCase();
        filtered = filtered.filter((o) =>
          o.instructorName?.toLowerCase().includes(lowerSearch) ||
          o.schoolName?.toLowerCase().includes(lowerSearch) ||
          o.phoneNumber?.includes(lowerSearch) ||
          o.instructorPhoneNumber?.includes(lowerSearch) ||
          o.schoolOwnerId?.toLowerCase().includes(lowerSearch) ||
          o.instructorId?.toLowerCase().includes(lowerSearch)
        );
      }

      // Sort
      filtered.sort((a, b) => {
        const dateA = a[sort]?.seconds || 0;
        const dateB = b[sort]?.seconds || 0;
        return order === 'asc' ? dateA - dateB : dateB - dateA;
      });

      const start = currentPage * 10;
      const paginated = filtered.slice(start, start + 10);

      setInstructors(paginated);
      setPageCount(Math.ceil(filtered.length / 10));
    };

    applyFilters();
  }, [allInstructors, filters, sort, order, currentPage, search]);

  useEffect(() => {
      const params = new URLSearchParams(location.search);
      const idFromUrl = params.get('instructorId');
      if (idFromUrl) {
        setSearch(idFromUrl);
      }
    }, [location.search]);
    useEffect(() => {
      const params = new URLSearchParams(location.search);
      const NameFromUrl = params.get('instructorName');
      if (NameFromUrl) {
        setSearch(NameFromUrl);
      }
    }, [location.search]);

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
  };

  const handleFilterChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
    setCurrentPage(0);
  };

  const handleSortChange = (field) => {
    setSort(field);
    setOrder(order === 'asc' ? 'desc' : 'asc');
    setCurrentPage(0);
  };

  const toggleRow = (id) => {
    setExpandedRows((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const getDocumentLinks = (documents) => {
    const availableDocs = [];
    if (documents?.profileImagePath?.length)
      availableDocs.push({ name: 'Bank Proof', path: documents.profileImagePath[0] });
    if (documents?.drivingLicensePath?.length)
      availableDocs.push({ name: 'Permit', path: documents.drivingLicensePath[0] });
    if (documents?.aadhaarCardPath?.length)
      availableDocs.push({ name: 'Aadhaar', path: documents.aadhaarCardPath[0] });
    if (documents?.panCardPath?.length)
      availableDocs.push({ name: 'PAN', path: documents.panCardPath[0] });
    return availableDocs;
  };

  return (
    <div className="p-6">
      <h2 className="text-2xl font-poppins text-driveeasy-blue dark:text-driveeasy-blue2 mb-4">Instructor Documents</h2>

      {/* Search and Filters */}
      <div className="mb-4 flex flex-wrap items-center gap-4">
        <input
          type="text"
          placeholder="Search by name, school, phone..."
          className="p-2 border rounded-md w-72 bg-white dark:bg-neutral-700 dark:border-neutral-600 dark:text-gray-200"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <select name="approvalStatus" value={filters.approvalStatus} onChange={handleFilterChange} className="p-2 border rounded-md bg-white dark:bg-neutral-700 dark:border-neutral-600 dark:text-gray-200">
          <option value="">All Statuses</option>
          <option value="PENDING">Pending</option>
          <option value="APPROVED">Approved</option>
          <option value="REJECTED">Rejected</option>
        </select>
        <select name="isDualRole" value={filters.isDualRole} onChange={handleFilterChange} className="p-2 border rounded-md bg-white dark:bg-neutral-700 dark:border-neutral-600 dark:text-gray-200">
          <option value="">All Roles</option>
          <option value="true">Dual Role</option>
          <option value="false">Non-Dual Role</option>
        </select>
        <select name="isOnboardingComplete" value={filters.isOnboardingComplete} onChange={handleFilterChange} className="p-2 border rounded-md bg-white dark:bg-neutral-700 dark:border-neutral-600 dark:text-gray-200">
          <option value="">All Onboarding</option>
          <option value="true">Complete</option>
          <option value="false">Incomplete</option>
        </select>
      </div>

      {/* Table */}
      <div className="overflow-x-auto">
        <table className="min-w-full bg-white dark:bg-neutral-800 shadow rounded-lg text-sm border border-gray-100 dark:border-neutral-800">
          <thead>
            <tr className="bg-driveeasy-blue text-white dark:bg-neutral-700 dark:text-gray-200">

              <th className="p-3 text-left">Doc ID</th>
              <th className="p-3 text-left">School Name</th>
              <th className="p-3 text-left">Instructor Name</th>
              <th className="p-3 text-left">Phone Number</th>
              <th className="p-3 text-left">Approval Status</th>
              <th className="p-3 text-left">Documents</th>
              <th
                className="p-3 text-left cursor-pointer"
                onClick={() => handleSortChange('createdAt')}
              >
                Joined Date {sort === 'createdAt' && (order === 'asc' ? '↑' : '↓')}
              </th>
              <th className="p-3 text-left">Actions</th>
              <th className="p-3 text-left">
                  <input
                    type="checkbox"
                    checked={selectedUids.length === instructors.length && instructors.length > 0}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setSelectedUids(instructors.map((o) => o.instructorId));
                      } else {
                        setSelectedUids([]);
                      }
                    }}
                  />
                </th>
            </tr>
          </thead>
          <tbody>
            {instructors.length > 0 ? instructors.map((instructor) => (
              <React.Fragment key={instructor.instructorId}>
                <tr className="border-b border-gray-200 dark:border-neutral-700 hover:bg-gray-50 dark:hover:bg-neutral-700/70 text-black dark:text-gray-300">
                  <td
                    className="p-3 text-driveeasy-blue hover:underline cursor-pointer"
                    onClick={() => {
                      setSelectedInstructor(instructor);
                      setProfileModalOpen(true);
                    }}
                  >
                    {instructor.instructorId}
                  </td>
                  <td className="p-3">{instructor.schoolName || 'N/A'}</td>
                  <td className="p-3">{instructor.instructorName || 'N/A'}</td>
                  <td className="p-3">{instructor.instructorPhoneNumber || instructor.phoneNumber || 'N/A'}</td>
                 <td className="p-3">
                   {editModeUid === instructor.instructorId ? (
                     <select
                       value={editedStatus}
                       onChange={(e) => setEditedStatus(e.target.value)}
                       className="border p-1 rounded"
                     >
                       {['PENDING', 'APPROVED', 'REJECTED'].map((status) => (
                         <option key={status} value={status}>{status}</option>
                       ))}
                     </select>
                   ) : (
                     <span className={`px-2 py-1 rounded ${instructor.approvalStatus === 'PENDING'
                       ? 'bg-orange-500' : instructor.approvalStatus === 'APPROVED'
                         ? 'bg-green-500' : 'bg-red-500'} text-white`}>
                       {instructor.approvalStatus || 'N/A'}
                     </span>
                   )}
                 </td>
                  <td className="p-3">
                    {getDocumentLinks(instructor.documents).map((doc) => (
                      <div key={doc.name}>
                        <a href={doc.path} target="_blank" rel="noopener noreferrer" className="text-driveeasy-blue hover:underline">
                          {doc.name}
                        </a>
                      </div>
                    ))}
                  </td>
                  <td className="p-3">
                    {instructor.createdAt?.seconds ? new Date(instructor.createdAt.seconds * 1000).toLocaleDateString() : 'N/A'}
                  </td>
                  <td className="p-3">
                    <button onClick={() => toggleRow(instructor.instructorId)}>
                      <FaEye className={expandedRows[instructor.instructorId] ? 'text-driveeasy-yellow' : 'text-driveeasy-blue'} />
                    </button>
                  </td>

                  <td className="p-3">
                      <input
                        type="checkbox"
                        checked={selectedUids.includes(instructor.instructorId)}
                        onChange={() =>
                          setSelectedUids((prev) =>
                            prev.includes(instructor.instructorId)
                              ? prev.filter((id) => id !== instructor.instructorId)
                              : [...prev, instructor.instructorId]
                          )
                        }
                      />
                    </td>
                </tr>
                {expandedRows[instructor.instructorId] && (
                  <tr>
                    <td colSpan="8" className="p-3 bg-gray-50 text-sm dark:bg-neutral-800">
                      <div className="grid grid-cols-2 gap-4">
                        <div>
                          <h4 className="font-poppins text-driveeasy-blue">School Details</h4>
                          <p>School Owner Id: {instructor.schoolOwnerId || 'N/A'}</p>
                          <p>Location: {instructor.schoolLocation?.latitude || 'N/A'}, {instructor.schoolLocation?.longitude || 'N/A'}</p>
                          <p>Bio: {instructor.bio || 'N/A'}</p>
                          <p>Rating: {instructor.rating || 'N/A'}</p>
                          <p>Years of Experience: {instructor.yearsOfExperience || 'N/A'}</p>
                        </div>
                        <div>
                          <h4 className="font-poppins text-driveeasy-blue">Document Details</h4>
                          <p>Aadhaar Number: {instructor.aadhaarNumber || 'N/A'}</p>
                          <p>PAN Number: {instructor.panNumber || 'N/A'}</p>
                          <p>Driving License Number: {instructor.drivingLicenseNumber || 'N/A'}</p>
                          <p>Dual Role: {instructor.isDualRole ? '✅' : '❌'}</p>
                          <p>Onboarding Complete: {instructor.isOnboardingComplete ? '✅' : '❌'}</p>
                          <h4 className="font-poppins text-driveeasy-blue mt-2">Sub-Collections</h4>
                          <p>Bookings: {instructor.cars?.map((bookings) => bookings.id).join(', ') || 'None'}</p>
                        </div>
                      </div>
                    </td>
                  </tr>
                )}
              </React.Fragment>
            )) : (
              <tr>
                <td colSpan="8" className="text-center p-4">No records found.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <ReactPaginate
        previousLabel={'Previous'}
        nextLabel={'Next'}
        pageCount={pageCount}
        onPageChange={handlePageChange}
        containerClassName={'flex justify-center mt-4 space-x-2'}
        pageClassName={'px-3 py-1 border rounded border-gray-200 dark:border-neutral-600 hover:bg-driveeasy-blue hover:text-white dark:text-gray-100'}
       activeClassName={'bg-driveeasy-blue text-white'}
       previousClassName={'px-3 py-1 border rounded border-gray-200 dark:border-neutral-700 hover:bg-driveeasy-blue hover:text-white dark:text-gray-100'}
       nextClassName={'px-3 py-1 border rounded border-gray-200 dark:border-neutral-700 hover:bg-driveeasy-blue hover:text-white dark:text-gray-100'}
     />
      {selectedUids.length > 0 && (
        <div className="fixed bottom-4 left-1/2 transform -translate-x-1/2 bg-white dark:bg-neutral-800 border border-gray-300 dark:border-neutral-600 shadow-lg px-6 py-3 rounded-lg flex items-center gap-4 z-50 text-gray-700 dark:text-gray-400">
          <span className="text-gray-700 dark:text-white">{selectedUids.length} selected</span>
          <button
            onClick={() => {
              setBulkAction('approve');
              setShowConfirmModal(true);
            }}
            className="bg-green-500 text-white px-3 py-1 rounded"
          >
            Approve Selected
          </button>
          <button
            onClick={() => {
              setBulkAction('reject');
              setShowConfirmModal(true);
            }}
            className="bg-red-500 text-white px-3 py-1 rounded"
          >
            Reject Selected
          </button>
          <button
            onClick={() => setSelectedUids([])}
            className="text-gray-600 underline dark:text-white underline"
          >
            Clear
          </button>
        </div>
      )}
      {showConfirmModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white dark:bg-neutral-800 dark:text-gray-200 p-6 rounded shadow-lg w-96 border border-gray-200 dark:border-neutral-700">
              <h2 className="text-lg font-bold mb-4">Confirm Action</h2>
              <p className="mb-4">
                {bulkAction === 'single'
                  ? `Are you sure you want to update status to "${editedStatus}"?`
                  : `Are you sure you want to ${bulkAction} ${selectedUids.length} selected  instructors?`}
              </p>
              <div className="flex justify-end gap-4">
                <button onClick={() => setShowConfirmModal(false)} className="text-gray-600">Cancel</button>
                <button
                  onClick={async () => {
                    setIsLoading(true);
                    try {
                      if (bulkAction === 'single') {
                        await updateApprovalStatusInstructor(editModeUid, editedStatus);
                        setAllInstructors((prev) =>
                          prev.map((o) =>
                            o.instructorId === editModeUid ? { ...o, approvalStatus: editedStatus } : o
                          )
                        );
                        setEditModeUid(null);
                      } else {
                        const updated = await Promise.all(
                          selectedUids.map((instructorId) =>
                            updateApprovalStatusInstructor(instructorId, bulkAction === 'approve' ? 'APPROVED' : 'REJECTED')
                          )
                        );
                        setAllInstructors((prev) =>
                          prev.map((o) =>
                            selectedUids.includes(o.instructorId)
                              ? { ...o, approvalStatus: bulkAction === 'approve' ? 'APPROVED' : 'REJECTED' }
                              : o
                          )
                        );
                        setSelectedUids([]);
                      }
                      setShowConfirmModal(false);
                    } catch (error) {
                      console.error("Update failed", error);
                    } finally {
                      setIsLoading(false);
                    }
                  }}
                  className="bg-driveeasy-blue text-white px-4 py-2 rounded"
                  disabled={isLoading}
                >
                  {isLoading ? 'Processing...' : 'Confirm'}
                </button>
              </div>
            </div>
          </div>
        )}
        {profileModalOpen && selectedInstructor && (
          <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center">
            <div className="bg-white dark:bg-neutral-800 dark:text-gray-200 p-6 rounded-lg max-w-2xl w-full max-h-[80vh] overflow-y-auto shadow-xl border border-gray-200 dark:border-neutral-700">
              <h3 className="text-xl font-bold mb-4 text-driveeasy-blue">Full Profile</h3>
              <div className="grid grid-cols-2 gap-4 text-sm">
                <div>
                  <h4 className="font-semibold text-driveeasy-blue">Instructor Info</h4>
                  <p><strong>UID:</strong> {selectedInstructor.instructorId}</p>
                  <p><strong>Instructor Name:</strong> {selectedInstructor.instructorName || 'N/A'}</p>
                  <p><strong>Phone:</strong> {selectedInstructor.phoneNumber || selectedInstructor.instructorPhoneNumber || 'N/A'}</p>
                  <p><strong>Aadhaar:</strong> {selectedInstructor.aadhaarNumber || 'N/A'}</p>
                  <p><strong>PAN:</strong> {selectedInstructor.panNumber || 'N/A'}</p>
                  <p><strong>Driving License:</strong> {selectedInstructor.drivingLicenseNumber || 'N/A'}</p>
                  <p><strong>Approval Status:</strong> {selectedInstructor.approvalStatus}</p>
                  <p><strong>Dual Role:</strong> {selectedInstructor.isDualRole ? 'Yes' : 'No'}</p>
                  <p><strong>Onboarding Complete:</strong> {selectedInstructor.isOnboardingComplete ? 'Yes' : 'No'}</p>
                </div>
                <div>
                  <h4 className="font-semibold text-driveeasy-blue">Details</h4>
                  <p><strong>School Name:</strong> {selectedInstructor.schoolName || 'N/A'}</p>
                  <p><strong>School Owner Id:</strong> {selectedInstructor.schoolOwnerId || 'N/A'}</p>
                  <p><strong>Bio:</strong> {selectedInstructor.bio || 'N/A'}</p>
                  <p><strong>Rating:</strong> {selectedInstructor.rating || 'N/A'}</p>
                  <p><strong>Years of Experience:</strong> {selectedInstructor.yearsOfExperience || 'N/A'}</p>
                  <p><strong>Location:</strong> {selectedInstructor.schoolLocation?.latitude || 'N/A'}, {selectedInstructor.schoolLocation?.longitude || 'N/A'}</p>
                </div>
              </div>

              <div className="mt-4 flex justify-end">
                <button
                  className="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600"
                  onClick={() => setProfileModalOpen(false)}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        )}
    </div>
  );
};

export default InstructorsDocuments;
